import { getShowtimeById } from '@vista-digital/occ-domain'
import type { TicketingWorkflowState } from '@/content/services/workflows/ticketing/ticketing-workflow-state'

export const isUnallocatedSeating = (state: TicketingWorkflowState) => {
    if (state?.showtimeId && getShowtimeById(state.showtimeId)?.isAllocatedSeating === false) {
        return true
    }

    return false
}
